import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import 'date-fns';
import { Backdrop, Box, Card, CardContent, CircularProgress, Container, Grid, Button, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable, { MTableToolbar } from 'material-table'
import { EmailAuditService } from "../../services";
import TableIcons from '../../materialTableIcons';
import { Magnify, TextBoxSearchOutline } from "mdi-material-ui";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import startOfYesterday from 'date-fns/startOfYesterday';
import '../GridStyleOverrides/materialTableHome.css'
import { SET_FORM_DATA_FROM_TABLE_EMAIL_AUDIT, SET_START_DATE, SET_END_DATE } from '../../actions/types';

//Many of these stylings aren't being used,  Material Table doesn't handle classNames
const useStyles = makeStyles((theme) => ({
    textInput: {
        '& label.Mui-focused': {
            color: theme.palette.text.primary,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#86C1D4',
            },
            '&:hover fieldset': {
                borderColor: theme.palette.text.primary,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.text.primary,
            },
        },
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        marginLeft: 10,
        marginRight: 20,
        paddingRight: 30
    },
    cardFiltersContainer: {
        marginTop: 20,
        backgroundColor: theme.palette.background.paper
    },
    cardContentForFiltersContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        backgroundColor: theme.palette.background.paper
    },
    filterDropdownsContainer: {
        minWidth: '80%',
        paddingLeft: 20,
        paddingRight: 20
    },
    gridItem: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
    },
    showAllAndFilterButtonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    showAllButton: {
        width: 140,
        marginBottom: 8,
    },
    filterButton: {
        width: 140,
        marginTop: 8,
    },
    card: {
        display: 'block',
        marginTop: 20,
        marginBottom: 30,
        paddingTop: 20,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: theme.palette.background.paper,
    },
    inputGridContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: 0,
        justifyContent: 'space-between'
    },
    exportButton: {
        width: 140,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    searchButton: {
        width: 180,
        fontWeight: 'bold',
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    inputLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: '1rem',
        marginRight: '1rem',
        color: theme.palette.text.secondary,
        width: '4rem',
        fontSize: 16,
        zIndex: 1000,
        lineHeight: 1.75,
        fontWeight: 'bold',
    },
    textField: {
        width: 220,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    createNewButton: {
        marginLeft: 20,
    },
    tableHeader: {
        backgroundColor: '#86C1D4'
    },
    tankMidnightTable: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 20,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellTitle': {
            fontWeight: 700,
            color: theme.palette.background.paper,
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellSortable': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-columnSeparator': {

        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

//The following objects can be modified here as needed then passed as options to the table:
const headerStyle = {
    backgroundColor: '#86C1D4',
    color: 'white',
    height: 49,
    textTransform: 'uppercase',
}
const rowStyle = {
    maxHeight: 50,
}

export default function EmailAuditHome() {

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const startDateFromStore = useSelector(state => state.emailAudit.startDate)
    const endDateFromStore = useSelector(state => state.emailAudit.endDate)

    const [isTableLoading, setIsTableLoading] = useState(true);

    const [dataSource, setDataSource] = useState([]);
    const [dataForTable, setDataForTable] = useState([]);
    const [freeSearchValue, setFreeSearchValue] = useState('');
    const [startDate, setStartDate] = useState(startDateFromStore ? startDateFromStore : startOfYesterday);

    let now = new Date()
    const [endDate, setEndDate] = useState(endDateFromStore ? endDateFromStore : now);

    //APPLY FILTERS/SEARCH
    useEffect(() => {
        let data = [...dataSource];
        if (dataSource) {
            if (freeSearchValue) {
                let query = freeSearchValue.toLowerCase().trim();
                let applySearch = dataSource.filter((item) => {
                    return (
                        item.senderEmail?.toLowerCase().indexOf(query) >= 0 ||
                        item.emailStatus?.toLowerCase().indexOf(query) >= 0 ||
                        item.emailSubject?.toLowerCase().indexOf(query) >= 0 ||
                        item.remark?.toLowerCase().indexOf(query) >= 0
                    )
                })
                data = applySearch
            }
            if (startDate) {
                data = data.filter(x => {
                    let d = new Date(x.createDate)
                    if (d >= startDate) {
                        return d
                    }
                })
            }
            if (endDate) {
                data = data.filter(x => {
                    let d = new Date(x.createDate)
                    if (d <= endDate) {
                        return d
                    }
                })
            }
            setDataForTable([...data])
        }
    }, [dataSource, freeSearchValue, startDate, endDate])

    useEffect(() => {
        async function fetchEmails() {
            let data = await EmailAuditService.getEmailAudits();
            data = data.sort((a, b) => new Date(b.createDate) -  new Date(a.createDate));
            setDataSource(data);
            setIsTableLoading(false);
        }
        fetchEmails()
    }, []);

    const handleFreeSearchChange = (event) => {
        setFreeSearchValue(event.target.value)
        //string
    };
    const handleStartDateChange = (date) => {
        setStartDate(date);
        dispatch({
            type: SET_START_DATE,
            payload: date,
        });
    };
    const handleEndDateChange = (date) => {
        setEndDate(date);
        dispatch({
            type: SET_END_DATE,
            payload: date,
        });
    };

    const columnDefs = [
        {
            title: 'Sent Date',
            field: 'createDate',
            cellStyle: { width: 100, minWidth: 100, maxWidth: 100, paddingLeft: 50 },
            headerStyle: { paddingLeft: 50 },
            render: rowData => {
                if (rowData && rowData.createDate) {
                    if (typeof rowData.createDate === 'string') {
                        return rowData.createDate.substring(0, 10)
                    } else {
                        return rowData.createDate.toString().substring(0, 10)
                    }
                }
            }

        },
        {
            title: 'Sent By',
            field: 'senderEmail',
            cellStyle: { width: 100, minWidth: 100, maxWidth: 100 }
        },
        {
            title: 'Sent Status',
            field: 'emailStatus',
            cellStyle: { width: 100, minWidth: 100, maxWidth: 100 },
        },
        {
            title: 'Email Subject',
            field: 'emailSubject',
            cellStyle: { width: 400, minWidth: 400, maxWidth: 400 }
        },
        {
            title: 'Remark',
            field: 'remark',
            cellStyle: { width: 200, minWidth: 200, maxWidth: 200 }
        },

    ]

    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Email Audit
                    </h2>
                </div>
                <Card className={classes.card}>

                    <Grid container spacing={2} className={classes.filterDropdownsContainer} >

                        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.gridItem}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    autoOk={true}
                                    size="small"
                                    fullWidth
                                    disableFuture
                                    inputVariant="outlined"
                                    format="dd-MMM-yyyy"
                                    id="date"
                                    label='Start Date'
                                    value={startDate}
                                    onChange={handleStartDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.gridItem}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    autoOk={true}
                                    size="small"
                                    fullWidth
                                    disableFuture
                                    inputVariant="outlined"
                                    format="dd-MMM-yyyy"
                                    id="date"
                                    label='End Date'
                                    value={endDate}
                                    onChange={handleEndDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item xs={12} sm={4} md={4} lg={4} className={classes.gridItem}>
                            <TextField
                                id="search"
                                name="search"
                                variant='outlined'
                                size='small'
                                fullWidth
                                label='Type to filter results...'
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton disabled={true}>
                                                <Magnify />
                                            </IconButton>
                                        </InputAdornment>
                                }}
                                disabled={dataSource?.length === 0}
                                value={freeSearchValue}
                                onChange={(event) => {
                                    handleFreeSearchChange(event);
                                }}
                            />
                        </Grid>

                    </Grid>
                    <Box px={1.5} className={classes.tankMidnightTable}>
                        <MaterialTable
                            style={{ width: '100%', boxShadow: 'none' }}
                            icons={TableIcons}
                            columns={columnDefs}
                            data={dataForTable}
                            title=""
                            //hide the default toolbar
                            components={{
                                Toolbar: props => (
                                    <div style={{ width: 0, height: 0 }}>
                                        <MTableToolbar {...props} />
                                    </div>
                                ),
                            }}
                            localization={{
                                header: {
                                    actions: 'Details'
                                }
                            }}
                            options={{
                                actionsCellStyle: { paddingLeft: 20, paddingRight: 20, width: 100, justifyContent: 'center', textAlign: 'center' },
                                actionsColumnIndex: 0,
                                filtering: false,
                                search: false,
                                sorting: true,
                                headerStyle: headerStyle,
                                rowStyle: rowStyle,
                                maxBodyHeight: '600px',
                                showTitle: false,
                                toolbar: false,
                                paging: true,
                                pageSize: 10,
                                emptyRowsWhenPaging: true,
                                pageSizeOptions: [10, 20, 50],

                            }}
                            actions={[
                                {
                                    icon: () => <TextBoxSearchOutline style={{ color: 'gray' }} />,
                                    tooltip: 'Show Details',
                                    onClick: (event, rowData) => {
                                        dispatch({
                                            type: SET_FORM_DATA_FROM_TABLE_EMAIL_AUDIT,
                                            payload: { ...rowData },
                                        });
                                        history.push('/admin/email-audit/details')
                                    }
                                }
                            ]}
                        />
                    </Box>
                </Card>
            </Container >
            <Backdrop className={classes.backdrop} open={isTableLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}